<template>
  <div class="tab-buttons">
    <button
      v-if="isConversationActive && (hubInformation.menuTitle || hubConversationHistory.menuTitle)"
      :class="{ active: isActiveConversationTab }"
      @click="$emit('tab-change', tabs.ACTIVE_CONVERSATION)">
      {{ $t('conversation_hub.active_conversation_tab') }}
    </button>
    <button
      v-if="hubInformation.menuTitle"
      :class="{ active: isInformationTab }"
      @click="$emit('tab-change', tabs.INFORMATION)">
      {{ infoTitle }}
    </button>
    <button
      v-if="hubConversationHistory.menuTitle"
      :class="{ active: isConversationsTab }"
      @click="$emit('tab-change', tabs.CONVERSATIONS)">
      {{ conversationsTitle }}
    </button>
  </div>
</template>

<script>
// Config
import config from '../../config/conversationHub.js'

// Dependencies
import { mapGetters } from 'vuex'
export default {
  name: 'ConversationTabs',
  props: {
    conversationHub: {
      type: Object,
      required: true
    },
    activeTab: {
      type: String,
      required: true
    },
    isConversationActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabs: config.TABS
    }
  },
  computed: {
    ...mapGetters(['conversations']),
    hubInformation() {
      return (this.conversationHub && this.conversationHub.information) || {}
    },
    hubConversationHistory() {
      if (!this.conversations || this.conversations.length === 0) {
        return {}
      }
      return (this.conversationHub && this.conversationHub.conversationHistory) || {}
    },
    infoTitle() {
      return this.hubInformation.menuTitle || this.$t('conversation_hub.info_title')
    },
    conversationsTitle() {
      return this.hubConversationHistory.menuTitle || this.$t('conversation_hub.conversations_title')
    },
    isConversationsTab() {
      return this.activeTab === this.tabs.CONVERSATIONS
    },
    isActiveConversationTab() {
      return this.activeTab === this.tabs.ACTIVE_CONVERSATION
    },
    isInformationTab() {
      return this.activeTab === this.tabs.INFORMATION
    }
  }
}
</script>
